<script lang="ts">
	import { page } from '$app/stores';
	import type { HTMLAnchorAttributes, HTMLButtonAttributes } from 'svelte/elements';
	import { twMerge } from 'tailwind-merge';
	export let type: 'button' | 'anchor' = 'button';
	export let props = {};

	let className: string = '';
	export { className as class };

	type DatasetAttributes = Record<`data-${string}`, string>;
	type HTMLAttributesWithNoClass<T> = Omit<T, 'class'>;
	type ButtonProps = HTMLAttributesWithNoClass<HTMLButtonAttributes> | DatasetAttributes;
	type AnchorProps = HTMLAttributesWithNoClass<HTMLAnchorAttributes> | DatasetAttributes;
	type LabelProps = HTMLAttributesWithNoClass<HTMLLabelAttributes> | DatasetAttributes;
	type $$Props =
		| {
				type: 'button';
				class: string | undefined;
				props: ButtonProps;
		  }
		| {
				type: 'anchor';
				class: string | undefined;
				props: AnchorProps;
		  }
		| {
				type: 'label';
				class: string | undefined;
				props: LabelProps;
		  };

	$: componentClass = twMerge(
		'inline-flex h-14 items-center cursor-pointer justify-center whitespace-nowrap rounded-xl bg-primary p-7 text-center text-base/none font-semibold text-white',
		className
	);
</script>

{#if type === 'button'}
	<button class={componentClass} {...props} on:click>
		<slot />
	</button>
{:else if type === 'anchor'}
	<a
		class={componentClass}
		{...props}
		href={props.href?.startsWith('#') ? props.href : $page.data?.location?.origin + props.href}
	>
		<slot />
	</a>
{:else if type === 'label'}
	<label class={componentClass} {...props}>
		<slot />
	</label>
{/if}
